import { roleConstants } from '../../_constants';
import { roleService } from '../../_services';
import { alertActions, userActions } from '../index';
import { confirmPromptActions } from '../confirmPromptActions';
// import { history } from '../../_helpers';

export const roleActions = {
    getActiveRoles,
    getAllRoles,
    getRoleById,
    updateRole,
    createRole,
    deleteRole,
    searchRoles,
    activation,
    multipleInsert
};

function ROLEfetching() { return { type: roleConstants.ROLE_FETCHING } }
function ROLEfetched() { return { type: roleConstants.ROLE_FETCHED } }

function getActiveRoles() {
    return dispatch => {
        dispatch(userActions.allowLeavePage());
        roleService.getActiveRoles()
            .then(
                roles => dispatch(success(roles)),
                error => dispatch(alertActions.error(error.toString()))
            );
    };
    function success(roles) { return { type: roleConstants.GET_ACTIVE_ROLES, roles } }
}

function activation(id, isActive) {
    return dispatch => {
        dispatch(ROLEfetching());
        dispatch(userActions.notallowLeavePage());
        roleService.activation(id, isActive)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(ROLEfetched());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getRoleById(id));
                    dispatch(alertActions.success(isActive ? 'Role activated successfully' : 'Role deactivated successfully'))
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()))
                    dispatch(ROLEfetched());
                }
            );
    };
}

function searchRoles(skip, take, filter, search) {
    return dispatch => {
        dispatch(userActions.allowLeavePage());
        dispatch(ROLEfetched());
        roleService.searchRole(skip, take, filter, search)
            .then(
                roles => {
                    if (roles.length > 0) {
                        dispatch(searchRole(roles))
                        dispatch(ROLEfetched());
                    } else {
                        dispatch(alertActions.error(roles.message));
                        dispatch(ROLEfetched());
                    }
                },
                error => {
                    dispatch(alertActions.error(error.toString()))
                    dispatch(ROLEfetched());
                }
            );
    };
    function searchRole(roles) { return { type: roleConstants.SEARCH_ROLE, roles } }
}

function getAllRoles(skip, take) {
    return dispatch => {
        dispatch(ROLEfetching());
        dispatch(userActions.allowLeavePage());
        roleService.getAllRoles(skip, take)
            .then(
                roles => {
                    if (roles.length > 0) {
                        dispatch(success(roles));
                        dispatch(ROLEfetched());
                    } else {
                        dispatch(ROLEfetched());
                        dispatch(alertActions.warning('No more data to load'))
                    }
                },
                error => {
                    dispatch(alertActions.error(error.toString()))
                    dispatch(ROLEfetched());
                }
            );
    };
    function success(roles) { return { type: roleConstants.GET_ROLES, roles } }
}

function getRoleById(id) {
    return dispatch => {
        dispatch(ROLEfetching());
        dispatch(userActions.allowLeavePage());
        roleService.getRoleById(id)
            .then(
                role => {
                    dispatch(success(role))
                    dispatch(ROLEfetched());
                },
                error => {
                    dispatch(alertActions.error(error.toString()))
                    dispatch(ROLEfetched());
                }
            );

    };
    function success(role) { return { type: roleConstants.GET_ROLE_BY_ID, role } }
}

function updateRole(role, roleDetail, userProfile) {
    return dispatch => {
        dispatch(updatingRole(role));
        dispatch(userActions.notallowLeavePage());
        roleService.updateRole(role, roleDetail, userProfile)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(ROLEfetched());
                    dispatch(alertActions.success('Role updated successfully'))
                    window.location.href = '/system_account/roles';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.error(error.toString()))
                    dispatch(ROLEfetched());
                }
            );
    };
    function updatingRole() { return { type: roleConstants.UPDATE_ROLE } }
}

function createRole(role, userProfile) {
    return dispatch => {
        dispatch(ROLEfetching());
        dispatch(userActions.notallowLeavePage());
        roleService.createRole(role, userProfile)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(ROLEfetched());
                    dispatch(alertActions.success('Role added successfully'))
                    window.location.href = '/system_account/roles';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.error(error.toString()))
                    dispatch(ROLEfetched());
                }
            );
    };
}

function deleteRole(id, type, take) {
    return dispatch => {
        dispatch(ROLEfetching());
        dispatch(userActions.notallowLeavePage());
        roleService.deleteRole(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(ROLEfetched());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Role deleted successfully'));
                    switch (type) {
                        case "specific":
                            window.location.href = '/system_account/roles';
                            break;
                        default:
                            dispatch(getAllRoles(0, take));
                            break;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()))
                    dispatch(getAllRoles(0, take));
                    dispatch(ROLEfetched());
                }
            );
    };
}

function multipleInsert(role, roledetail, userProfile) {
    return dispatch => {
        dispatch(ROLEfetching());
        dispatch(userActions.notallowLeavePage());
        roleService.multipleInsert(role, roledetail, userProfile)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(ROLEfetched());
                    dispatch(alertActions.success('Role added successfully'))
                    window.location.href = '/system_account/roles';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.error(error.toString()))
                    dispatch(ROLEfetched());
                }
            );
    };
}